import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AliasService {
  private readonly http = inject(HttpClient);

  getAliasList(
    pageIndex: number,
    pageSize: number,
    sortBy: string,
    search: string
  ): Observable<any> {
    let params = new HttpParams()
      .set('pageIndex', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('sortBy', sortBy);

    const q = (search ?? '').trim();
    if (q) {
      params = params.set('search', q);
    }

    return this.http.get<any>(`${environment.api.host_path}/alias/list`, { params });
  }

  getAliasListAll(): Observable<any> {
    return this.http.get(`${environment.api.host_path}/alias/listAll`);
  }

  getAliasDocuments(limit: number, offset: number, aliasId: number, sortBy: string, q: string | null): Observable<any> {
    let params = new HttpParams()
      .set('limit', limit.toString())
      .set('offset', offset.toString())
      .set('aliasId', aliasId.toString())
      .set('sortBy', sortBy);

    if (q && q.trim().length > 0) {
      params = params.set('q', q.trim());
    }

    return this.http.get<any>(`${environment.api.host_path}/alias/listDocuments`, { params });
  }

  deleteDocuments(urls: string[]): Observable<any> {
    let params = new HttpParams();
    urls.forEach((url) => {
      params = params.append('urls', url);
    });
    return this.http.delete(`${environment.api.host_path}/delete-document`, { params });
  }

  addNewAlias(params: any): Observable<any> {
    return this.http.post(`${environment.api.host_path}/alias`, params);
  }

  deleteAlias(id: number): Observable<any> {
    return this.http.delete(`${environment.api.host_path}/alias/${id}`);
  }

  updateAliasName(params: any): Observable<any> {
    return this.http.put(`${environment.api.host_path}/alias`, params);
  }

  addOrUpdateFieldToAlias(params: any, aliasId: string): Observable<any> {
    return this.http.put(`${environment.api.host_path}/alias/${aliasId}/add-field`, params);
  }

  addOrUpdatePatternToAlias(params: any, aliasId: string): Observable<any> {
    return this.http.put(`${environment.api.host_path}/alias/${aliasId}/add-patterns`, params);
  }

  addIndexToAlias(aliasId: string, indexId: string): Observable<any> {
    return this.http.put(`${environment.api.host_path}/alias/${aliasId}/add-index/${indexId}`, null);
  }

  removeFieldFromAlias(aliasId: number, fieldId: number): Observable<any> {
    return this.http.delete(`${environment.api.host_path}/alias/${aliasId}/remove-field/${fieldId}`);
  }

  removePatternFromAlias(aliasId: number, patternId: number): Observable<any> {
    return this.http.delete(`${environment.api.host_path}/alias/${aliasId}/remove-patterns/${patternId}`);
  }

  removeIndexFromAlias(aliasId: string, indexId: number): Observable<any> {
    return this.http.delete(`${environment.api.host_path}/alias/${aliasId}/remove-index/${indexId}`);
  }
}